import { dataFiltered } from './dataFiltered';
import { noDataAvailable } from './noDataAvailable';
import { noDataInRequiredPaths } from './noDataInRequiredPaths';
import { noNumericFields } from './noNumericFields';
import { noNumericFieldsInComponentType } from './noNumericFieldsInComponentType';
import { noDataAvailableInDiscoverJourney } from './noDataAvailableInDiscoverJourney';
import { onlyZeroValuesForBubbleSize } from './onlyZeroValuesForBubbleSize';
import { onlyZeroValuesForBubbleSizeSelectedComponent } from './onlyZeroValuesForBubbleSizeSelectedComponent';
import { noViewpointBubbleFields } from './noViewpointBubbleFields';
import { noViewpointBubbleFieldsSelectedComponent } from './noViewpointBubbleFieldsSelectedComponent';

export const emptyStatePresets = {
  dataFiltered,
  noDataAvailable,
  noDataInRequiredPaths,
  noNumericFields,
  noNumericFieldsInComponentType,
  noDataAvailableInDiscoverJourney,
  onlyZeroValuesForBubbleSize,
  onlyZeroValuesForBubbleSizeSelectedComponent,
  noViewpointBubbleFields,
  noViewpointBubbleFieldsSelectedComponent,
};
